import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { DBRoomSchema, RoomSchema } from './schemas';

export const RoomCodecConfig: TransformerConfig<typeof RoomSchema, typeof DBRoomSchema> = {
  name: 'Room',
  clientSchema: RoomSchema,
  dbSchema: DBRoomSchema,
  transformers: [],
};

export const encodeRoomToDb = createEncodeToDbFn(RoomCodecConfig);
export const decodeRoomFromDb = createDecodeFromDbFn(RoomCodecConfig);
